/**
 * Captura UTM + gclid + fbclid no primeiro hit e persiste em sessionStorage.
 * Anexar ao payload do lead em todos os submits.
 */

export type Attribution = {
  gclid?: string;
  fbclid?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  landing_path?: string;
  referrer?: string;
  captured_at?: string;
};

const STORAGE_KEY = "sr_attribution_v1";
const TRACKED_PARAMS = [
  "gclid",
  "fbclid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

export const captureAttribution = (): Attribution => {
  if (typeof window === "undefined") return {};
  const existing = readAttribution();
  // Se já capturado nesta sessão, manter (first-touch attribution)
  if (existing && Object.keys(existing).length > 0) return existing;

  const params = new URLSearchParams(window.location.search);
  const attr: Attribution = {};
  for (const k of TRACKED_PARAMS) {
    const v = params.get(k);
    if (v) (attr as Record<string, string>)[k] = v;
  }
  attr.landing_path = window.location.pathname;
  attr.referrer = document.referrer || undefined;
  attr.captured_at = new Date().toISOString();

  // Só persiste se houver pelo menos UM parâmetro útil
  const hasParam = TRACKED_PARAMS.some(k => attr[k]);
  if (hasParam || attr.referrer) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attr));
    } catch {
      // sessionStorage pode falhar em modo privado
    }
  }
  return attr;
};

export const readAttribution = (): Attribution => {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Attribution) : {};
  } catch {
    return {};
  }
};
